module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "super-map"
  }, [_c('div', {
    attrs: {
      "id": "map"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb9987b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/super-map.vue
// module id = 341
// module chunks = 1